import React from 'react'
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom'


import FacultyHomeHelper from '../../Components/FacultyHomeHelper'


const FacultyInterface = () => {
    const history = useHistory()
    const store = useSelector((store) => store)
    return (
        <>
            {store.faculty.isAuthenticated ? <>
                <div className="container-fluid p-0">
                    <div className="d-flex">
                    <div className="print-helper">
                        <FacultyHomeHelper />
                    </div>
                    <div className="mx-1 w-100 ">
                    <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" />My Profile</h3>
                        <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                         </div>
                         <div className="row m-0">
                                <div className="col-md-4 ">
                                    <div className="card  " >
                                        <img className="card-img-top img-fluid" src={store.faculty.faculty.faculty.avatar} alt="Card image cap" />
                                        <div className="card-body">
                                                    <h5 className="card-title bg-dark text-light p-1">{store.faculty.faculty.faculty.name}</h5>
                                                <div className="">
                                                    <h6 className='d-flex align-items-center'><img src="/image/mail.svg" alt="" className='p-1' />{store.faculty.faculty.faculty.email}</h6>
                                                    <h6 className='d-flex align-items-center'><img src="/image/phone.svg" alt="" className='p-1' />{store.faculty.faculty.faculty.facultyMobileNUmber}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                        <div className="col-md-8">
                                        <table className="table border table table-striped table-bordered">
                                            <tbody>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td>{store.faculty.faculty.faculty.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email</td>
                                                        <td>{store.faculty.faculty.faculty.email}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Registration Number</td>
                                                        <td>{store.faculty.faculty.faculty.registrationNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date Of Birth</td>
                                                        <td>{store.faculty.faculty.faculty.dob}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Designation</td>
                                                        <td>{store.faculty.faculty.faculty.designation}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Joining Year</td>
                                                        <td>{store.faculty.faculty.faculty.joiningYear}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Department</td>
                                                        <td>{store.faculty.faculty.faculty.department}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gender</td>
                                                        <td>{store.faculty.faculty.faculty.gender ? store.faculty.faculty.faculty.gender :

                                                            "NA"
                                                        }</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Contact Number</td>
                                                        <td>{store.faculty.faculty.faculty.facultyMobileNUmber ?
                                                            store.faculty.faculty.faculty.facultyMobileNUmber : "NA"}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                <div className="col-md-2">

                                </div>
                    </div>
                    </div>
                </div>

            </> : (history.push('/'))}
           
        </>


    )
}

export default FacultyInterface
